<template>
  <div
    v-if="codes.length"
    class="list-item-codes"
  >
    <span
      v-for="(code, index) in filteredCodes"
      :key="code.id"
      class="code"
    >
      <span class="code__name">{{ code.name }}</span>
      <span v-if="index !== filteredCodes.length - 1">, </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { codeIs } from '@/lib/codes'
import type { CodeWithCategory } from '@/api/generated/v2'


const props = defineProps<{
  codes: CodeWithCategory[]
}>()

// 950/951 codes only; questionable, but this logic here since 2023
const filteredCodes = computed(() => props.codes.filter(codeIs.feed))
</script>

<style scoped>
.list-item-codes {
  font-size: 13px;
  color: #0681ec;
  text-shadow: 0.7px 0 #ccc;
  width: 100%;
}

.code__name {
  white-space: nowrap;
}
</style>
